import { PaginationProps } from "react-bootstrap";
import { ITestableComponentProps } from "../../../shared/types/testing.types";

export interface IPaginationProps
  extends ITestableComponentProps,
    PaginationProps {
  totalCount?: number;
}

export const DefaultPaginationProps = {
  totalCount: undefined,
};

export const PAGINATION_PAGE_SIZE = 12;
